"use client";

import type { ReactNode } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Button, Modal, ModalBody, ModalFooter } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";

export function PublicListingFilterField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  const theme = useThemeTokens();

  return (
    <Box minW={0} w="100%">
      <Text
        as="label"
        display="block"
        fontSize="sm"
        fontWeight="500"
        color={theme.text.primary}
        letterSpacing="-0.01em"
        mb="5px"
      >
        {label}
      </Text>
      {children}
    </Box>
  );
}

export function PublicListingFiltersModal({
  isOpen,
  onClose,
  title,
  onApply,
  onClearDraft,
  hasDraftCriteria,
  testId,
  applyTestId,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  onApply: () => void;
  onClearDraft: () => void;
  hasDraftCriteria: boolean;
  testId: string;
  applyTestId: string;
  children: ReactNode;
}) {
  const theme = useThemeTokens();

  const handleApply = () => {
    onApply();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      contentProps={{ "data-testid": testId }}
    >
      <ModalBody py={6}>
        <Flex direction="column" gap={5}>
          {children}
        </Flex>
      </ModalBody>
      <ModalFooter
        px={{ base: 4, md: 6 }}
        py={4}
        borderTopWidth="1px"
        borderTopColor={theme.borderGlass.default}
        gap={3}
      >
        <Button
          variant="outline"
          onClick={onClearDraft}
          isDisabled={!hasDraftCriteria}
        >
          Clear all
        </Button>
        <Button variant="primary" onClick={handleApply} data-testid={applyTestId}>
          Apply filters
        </Button>
      </ModalFooter>
    </Modal>
  );
}
